import CustomIcon from "../../components/CustomIcon";
import * as React from "react";
import {
  Text,
  View,
  Image,
  TouchableOpacity,
  StyleSheet,
  Dimensions,
  Linking,
  Platform,
} from "react-native";
import { ScrollView } from "react-native-gesture-handler";
import { useNavigation } from "@react-navigation/native";
import GlobalStyles from "../../components/GlobalStyles";
import { Auth } from "aws-amplify";
import { user_logout } from "../../redux/actions/UserActions";
import FooterBarWide from "../../components/footerBarWide";
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
// import InviteWebHeader from "../components/InviteWebHeader";
import { useSelector } from "react-redux";
import { Ionicons } from '@expo/vector-icons';
import Colors from "../../utilities/Color.js";

async function LogoutButton({ navigation }) {
  Auth.signOut().then(() => {
    user_logout();
    navigation.navigate("Welcome");
  });
}
export default function SettingsScreen() {
  const navigation = useNavigation();
  const win = Dimensions.get("window");
  const debugFlag = useSelector((state) => state.uistate.debugMode);
  const hasNotifications = useSelector(
    (state) => state.notifications.unreadNotifications
  );
  return (
    <View style={GlobalStyles.containerMB}>
      {win.width > 768 ? (
        <View style={GlobalStyles.fullHeaderBarY}>
          <MenuBar data="6" />
          <View style={GlobalStyles.headerContainerKLYellow}>
            <View style={GlobalStyles.headerTextYellow}>
              <Text style={GlobalStyles.headingStyle}>Settings</Text>
              <Text style={GlobalStyles.subheaderStyleWeb}>{"\n"}</Text>
            </View>
          </View>
        </View>
      ) : (
        <View style={GlobalStyles.fullHeaderBarW}>
          <StatusBar data="B" />
          <View style={GlobalStyles.headerContainerKL}>
            <View style={[GlobalStyles.headerText]}>
              <Text style={GlobalStyles.headingStyle}>Settings</Text>
            </View>
          </View>
        </View>
      )}
      <View style={GlobalStyles.adjustableBodyContainer}>
        <ScrollView style={styles.webBodyContainer}>
          <OptionButton
            icon="icon-entertainment"
            label="My Account"
            subtext="Your profile"
            onPress={() => {
              navigation.navigate("SettingsProfile");
            }}
          />
          <OptionButton
            icon="icon-creditcard"
            label="Linked Cards"
            subtext="Manage"
            onPress={() => {
              navigation.navigate("CardsHome");
            }}
          />
          <OptionButton
            icon="icon-invest"
            label="Transactions"
            subtext="View"
            onPress={() => {
              navigation.navigate("SpendingInsights");
            }}
          />
          <OptionButton
            icon="icon-notifications"
            label="Notifications"
            subtext="View/Manage"
            onPress={() => {
              navigation.navigate("NotificationListScreen");
            }}
            hasNotifications={hasNotifications}
          />
          {/* <OptionButton
            icon="icon-notifications"
            label="Statements"
            subtext="Financial reports"
            onPress={() => {
              navigation.navigate("Statement");
            }} /> */}
          {/* {Platform.OS === "web" ?
            (<OptionButton
              icon="icon-reports"
              label="Access Funds"
              subtext="Manage"
              onPress={() => navigation.navigate("ManageFund")}
            />) : (<OptionButton
              icon="icon-reports"
              label="Access Funds"
              subtext="Manage"
              onPress={() => navigation.navigate("ManageFund")}
            />
            )} */}

          {/* {Platform.OS === "web" ? (
            <OptionButton
              icon="icon-reports"
              label="T&Cs"
              subtext="More information"
              onPress={() =>
                window.open("https://aura.club/terms-and-conditions/", "_blank")
              }
            />
          ) : (
            <OptionButton
              icon="icon-reports"
              label="T&Cs"
              subtext="More information"
              onPress={() =>
                Linking.openURL("https://aura.club/terms-and-conditions/")
              }
            />
          )} */}
          {/*
          <OptionButton
            icon="icon-notifications"
            label="Notifications"
            subtext="Manage options"
          />

          <OptionButton
            icon="icon-reports"
            label="Reports"
            subtext="Donations, spend, EOFY & print"
          />
*/}

          {/* {Platform.OS === "web" ? (
            <OptionButton
              icon="icon-privacy"
              label="Privacy"
              subtext="Details"
              onPress={() =>
                window.open("https://aura.club/privacy-policy/", "_blank")
              }
            />
          ) : (
            <OptionButton
              icon="icon-privacy"
              label="Privacy"
              subtext="Details"
              onPress={() =>
                Linking.openURL("https://aura.club/privacy-policy/")
              }
            />
          )} */}
          {Platform.OS === "web" ? (
            <OptionButton
              icon="icon-help"
              label="Help"
              subtext="Questions?"
              onPress={() => window.open("https://aura.club/FAQs/", "_blank")}
            />
          ) : (
            <OptionButton
              icon="icon-help"
              label="Help"
              subtext="Questions?"
              onPress={() => Linking.openURL("https://aura.club/FAQs/")}
            />
          )}

          <OptionButton
            icon="icon-plane"
            label="Logout"
            subtext=""
            onPress={() => {
              LogoutButton({ navigation });
            }}
          />

          <TouchableOpacity
            activeOpacity={0.7}
            onPress={() => navigation.navigate("AboutUs")}
          >
            <View style={styles.containerBox}>
              <View style={styles.containerA}>
                <Image
                  source={require("../../assets/res/Aura_Alpha_WhiteBG.gif")}
                  style={styles.smallLogo}
                  resizeMode="contain"
                />
                <Text style={styles.logoText}>Find out more about Aura...</Text>
              </View>
            </View>
          </TouchableOpacity>
          <Text style={styles.versionText}>1.6.1c</Text>
        </ScrollView>
      </View>
      <View style={GlobalStyles.webFooter}>
        {win.width > 768 ? <FooterBarWide /> : null}
      </View>
    </View>
  );
}

function OptionButton({ icon, label, onPress, subtext, isLastOption, hasNotifications }) {
  var iconColour ;
  iconColour = "rgba(98,98,98,0.99)";
  if (label == 'Notifications' && hasNotifications) {
    iconColour = "rgba(230,184,0,0.99)";
  }
  if (label == 'Statements') {
    iconColour = "rgba(150,150,150,0.99)";
  }

  return (
    <TouchableOpacity
      style={styles.containerBox}
      activeOpacity={0.7}
      onPress={onPress}
    >
      <View style={styles.SubmitButtonStyle}>
        <View style={styles.optionIconContainer}>
          {label != 'Statements' ? <CustomIcon name={icon} size={24} color={iconColour} /> : <Ionicons name="document-outline" size={20} color={iconColour} />}
        </View>
        <View style={styles.optionTextContainer}>
          <Text style={styles.optionText}>{label}</Text>
        </View>
        <View style={styles.optionSubtextContainer}>
          <Text style={styles.optionSubtext}>{subtext}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  webBodyContainer: {
    flex: 1,
    width: "100%",
    maxWidth: 800,
    alignSelf: "center",
  },

  SubmitButtonStyle: {
    flexDirection: "row",
  },

  optionIconContainer: {
    flex: 2,
    alignSelf: "center",
  },

  optionTextContainer: {
    flex: 6,
    alignSelf: "center",
  },

  optionSubtextContainer: {
    flex: 6,
    alignSelf: "center",
  },

  optionText: {
    color: "#506685",
    fontFamily: "montserrat-bold",
    fontSize: 15,
    textAlign: "left",
  },

  optionSubtext: {
    color: "#000000",
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "right",
  },

  containerBox: {
    flex: 1,
    backgroundColor: "#ffffff",
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    paddingTop: 10,
    paddingLeft: 10,
    paddingRight: 10,
    paddingBottom: 10,
    marginBottom: 15,
  },

  containerA: {
    alignItems: "center",
    paddingTop: 20,
    paddingBottom: 20,
  },

  logoText: {
    paddingTop: 20,
  },

  versionText: {
    paddingTop: 20,
    paddingBottom: 20,
    color: "#000000",
    fontFamily: "montserrat-regular",
    fontSize: 10,
    textAlign: "center",
  },

  smallLogo: {
    width: 107,
    height: 60,
    resizeMode: "contain",
  },
});
